export default __webpack_public_path__ + "static/media/level-2.d0a4b776.png";